<template>
<div class="mypurchase-order">
    <div :class="{'bg-head-nav': true, 'bg-head-h187': isBgHeaderH187}"></div>
    <div class="area-1290 mypurchase-order-main">
        <div class="controller-container">
            <div class="controller-content">
                <el-select :class="{'action-select-first': true}" @change="selectInventory" v-model="inventoryIndex" placeholder="请选择仓库">
                    <el-option v-for="(item, index) in inventoryArr" :key="index" :label="item.warehouse_name" :value="index">
                    </el-option>
                </el-select>
                <el-button class="action-select-inventory" type="success" @click="selectAddress">选择收货地址</el-button>
                <el-button class="action-select-inventory" type="success" @click="addAddress">添加收货地址</el-button>
                <el-button class="goods-list-edit" v-show="!isDel" @click="isDel = !isDel" type="text" size="small">编辑</el-button>
                <el-button class="goods-list-edit" v-show="isDel" @click="isDel = !isDel" type="text" size="small">完成</el-button>
            </div>
        </div>
        <div class="table-container">
            <span class="table-select-all" @click="showCartData">全选</span>
            <!-- 经销商 -->
            <el-table key="1" v-if="userTypeNum == 1" ref="multipleTable" :header-cell-style="changeTableHeaderStyle" :cell-style="changeTableStyle" :data="cart" tooltip-effect="dark" style="width: 100%" @selection-change="selectGoods">
                <el-table-column type="selection" width="120">
                </el-table-column>
                <el-table-column prop="good_name" label="货品" align="center" min-width="40%">
                </el-table-column>
                <el-table-column prop="good_num" label="进货数量" align="center" min-width="30%">
                </el-table-column>
                <el-table-column prop="good_price" label="单价" align="center" min-width="30%">
                </el-table-column>
                <el-table-column prop="single_total_price" label="金额" align="center" min-width="30%">
                </el-table-column>
            </el-table>
            <!-- 汽服门店 -->
            <el-table key="2" v-if="userTypeNum == 2" ref="multipleTable" :data="cart" :header-cell-style="changeTableHeaderStyle" :cell-style="changeTableStyle" tooltip-effect="dark" style="width: 100%" @selection-change="selectGoods">
                <el-table-column type="selection" width="90">
                </el-table-column>
                <el-table-column prop="good_name" align="center" label="货品" min-width="35%">
                </el-table-column>
                <el-table-column prop="good_num" align="center" label="进货数量" min-width="12.5">
                </el-table-column>
                <el-table-column prop="good_price" align="center" label="单价" min-width="12.5">
                </el-table-column>
                <el-table-column prop="single_total_price" align="center" label="金额" min-width="12.5">
                </el-table-column>
                <el-table-column prop="last_price" align="center" label="最后敲定价格" min-width="12.5">
                </el-table-column>
                <el-table-column label="操作" align="center" min-width="15%">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" @click="changeLastPrice(scope.row)">修改金额</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="submitorder">
            <div class="submit-order-text">
                <p>
                    <span>已选: &nbsp;</span>
                    <span style="color: rgb(251, 67, 0);">{{selectCount}}</span>
                    <span>&nbsp;件</span>
                </p>
                <p :class="{'hide': isDel}">
                    <span>合计: &nbsp;&nbsp;</span>
                    ￥<span style="color: rgb(251, 67, 0);">{{selectTotalPrice}}</span>
                </p>
            </div>
            <el-button type="success" v-show="!isDel" class="btn-submitorder" @click="submitOrder">提交订单</el-button>
            <el-button type="danger" v-show="isDel" class="btn-submitorder" @click="delGoodsFromCart">删除订单</el-button>
            <el-button type="success" :class="{'return-prevpage': true, 'hide': isDel}" @click="addGoodsContinue">继续添加</el-button>
        </div>
    </div>
    <div class="dialog-group">
        <!-- 选择收地址 -->
        <el-dialog class="select-address" title="收货地址" :visible.sync="selectAddressDialogFormVisible">
            <el-form>
                <el-form-item v-for="(item, index) in addressArr" :key="index" label="" :label-width="selectAddressFormLabelWidth">
                    <el-radio v-model="addressIndex" :label="index">地址{{index}}</el-radio><br>
                    收货人：<span>{{item.gains_people_name}}</span><br>
                    电话：<span>{{item.phone}}</span><br>
                    收货地址：<span>{{item.address_detail}}</span><br>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="selectAddressDialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="selectAddressDialogFormVisible = false">确 定</el-button>
            </div>
        </el-dialog>
        <!-- 添加收货地址 -->
        <el-dialog class="add-address" title="添加地址" :visible.sync="addAddressDialogFormVisible">
            <el-form :model="addAddressForm">
                <el-form-item label="收货人" :label-width="addAddressFormLabelWidth">
                    <el-input v-model="addAddressForm.gains_people_name" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="电话" :label-width="addAddressFormLabelWidth">
                    <el-input v-model="addAddressForm.phone" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="详细地址" :label-width="addAddressFormLabelWidth">
                    <el-input v-model="addAddressForm.address_detail" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="邮政编码" :label-width="addAddressFormLabelWidth">
                    <el-input v-model="addAddressForm.zipcode" autocomplete="off"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="addAddressDialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="addAddressOk">确 定</el-button>
            </div>
        </el-dialog>
        <!-- 添加最后敲定价格 -->
        <el-dialog class="change-last-price" title="修改价格" :visible.sync="changeLastPriceDialogFormVisible">
            <el-form>
                <el-form-item label="敲定价格" :label-width="changeLastPriceFormLabelWidth">
                    <el-input v-model="currentGoodsObj.last_price" autocomplete="off"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="changeLastPriceQuit">取 消</el-button>
                <el-button type="primary" @click="changeLastPriceDialogFormVisible = false">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</div>
</template>

<script>
import {
    mapGetters,
    mapMutations,
    mapActions
} from 'vuex';
import Tool from '../../assets/js/Tool.js';
export default {
    data() {
        return {
            isHide: true,
            isBgHeaderH187: false,
            isDel: false,
            selectCount: 0,
            selectTotalPrice: 0,
            tableData: [],
            inventoryIndex: 0,
            inventoryArr: [],
            addressArr: [],
            addressIndex: -1,
            selectAddressDialogFormVisible: false,
            selectAddressFormLabelWidth: '120px',
            addAddressForm: {
                zipcode: '',
                gains_people_name: '',
                phone: '',
                address_detail: '',
            },
            addAddressDialogFormVisible: false,
            addAddressFormLabelWidth: '120px',
            submitGoodsArr: [],
            isSelectAll: false,
            changeLastPriceDialogFormVisible: false,
            changeLastPriceFormLabelWidth: '120px',
            currentGoodsObj: '',
            currentGoodsObjCopy: ''
        }
    },
    computed: {
        ...mapGetters(['user', 'userTypeNum', 'cart'])
    },
    created() {
        this.init();
    },
    methods: {
        ...mapMutations(['initCart']),
        // ...mapActions([]),
        changeTableHeaderStyle({
            row,
            rowIndex
        }) {
            return 'color:black; font-weight: bold;';
        },
        changeTableStyle({
            row,
            column,
            rowIndex,
            columnIndex
        }) {
            return 'color: #000;'
        },
        showCartData() {
            console.log(this.cart);
        },
        init() {
            this.axios.get('shoppingwarehouse', {
                    params: {
                        style: 0,
                        user_id: this.user.id
                    }
                })
                .then(res => {
                    this.inventoryArr = res.data.data;
                    this.getCartData();
                })
        },
        // 选择收货地址
        selectAddress() {
            this.axios.get('show_deliveryaddress', {
                params: {
                    user_id: this.user.id
                }
            })
            .then(res => {
                this.addressArr = res.data.data;
                this.selectAddressDialogFormVisible = true;
            })
        },
        // 添加收货地址
        addAddress() {
            this.addAddressDialogFormVisible = true;
        },
        addAddressOk() {
            var sendObj = Object.assign(this.addAddressForm, {
                user_id: this.user.id
            });

            this.axios.post('add_deliveryaddress', JSON.stringify(sendObj))
            .then(res => {
                this.$message({
                    type: 'success',
                    message: res.data.msg
                });
                this.addAddressDialogFormVisible = false;
            })
        },
        // 继续添加商品到购物车
        addGoodsContinue() {
            this.$router.push({
                'name': 'productinfo'
            });
        },
        // 提交订单
        submitOrder() {
            if(this.submitGoodsArr.length == 0) {
                this.$message({
                    type: 'error',
                    message: '未选择商品！'
                });
                return;
            }
            if(this.addressIndex == -1) {
                this.$message({
                    type: 'error',
                    message: '未选择地址！'
                });
                return;
            }
            var item_str = [];
            this.submitGoodsArr.forEach(item => {
                if(this.userTypeNum == 1) {
                    item_str.push({
                        sc_id: item.id
                    })
                }
                else if(this.userTypeNum == 2) {
                    item_str.push({
                        sc_id: item.id,
                        last_price: parseFloat(item.last_price)
                    })
                }
            })
            var sendObj = {
                address_id: this.addressArr[this.addressIndex].id,
                warehouse_id: this.inventoryArr[this.inventoryIndex].warehouse_id,
                order_id: Tool.getUniqueRandom(),
                user_id: this.user.id,
                item_str: item_str
            }
            this.axios.post('send_order', JSON.stringify(sendObj))
            .then(res => {
                if(res.data.status == 1){
                    this.getCartData(() =>{
                        this.$message({
                            type: 'success',
                            message: res.data.msg
                        })
                    })
                }
                else if(res.data.status == 2 || res.data.status == 0) {
                    this.getCartData(() =>{
                        this.$message({
                            type: 'error',
                            message: res.data.msg
                        })
                    })
                }
            })

        },
        // 删除商品
        delGoodsFromCart() {
            if(this.submitGoodsArr.length == 0) {
                this.$message({
                    type: 'error',
                    message: '未选择商品！'
                });
                return;
            }
            var sc_ids = [];
            this.submitGoodsArr.forEach(item => {
                sc_ids.push(item.id);
            })
            var sendObj = {
                sc_ids: sc_ids
            };
            this.axios.post('delete_shoppingcart', JSON.stringify(sendObj))
            .then(res => {
                this.submitGoodsArr = [];
                this.getCartData(() =>{
                    this.$message({
                        'type': 'success',
                        'message': res.data.msg
                    })
                })
            })
        },
        // 修改最后敲定价格
        changeLastPrice(rowData) {
            this.currentGoodsObj = rowData
            this.currentGoodsObjCopy = JSON.parse(JSON.stringify(this.currentGoodsObj));
            this.changeLastPriceDialogFormVisible = true;
        },
        changeLastPriceQuit() {
            alert('changeLastPriceQuit')
            console.log(JSON.stringify(this.currentGoodsObj))
            console.log(JSON.stringify(this.currentGoodsObjCopy))
            this.currentGoodsObj.last_price = this.currentGoodsObjCopy.last_price;
            this.changeLastPriceDialogFormVisible = false;
        },
        // 选择对应仓库的购物车列表
        selectInventory(inventoryIndex) {
            this.getCartData();
        },
        // 请求购物车数据
        getCartData(callback) {
            if (this.userTypeNum == 2) {
                if (this.user.role.role_num == 1) {
                    var style = 1;
                } else {
                    var style = 0;
                }
            } else {
                var style = 0;
            }

            this.axios.get('shopping_cart', {
                    params: {
                        style: style,
                        user_id: this.user.id,
                        warehouse_id: this.inventoryArr[this.inventoryIndex].warehouse_id
                    }
                })
                .then(res => {
                    res.data.data.forEach(item => {
                        item.last_price = parseFloat(item.single_total_price);
                    })
                    this.initCart(res.data.data);
                    // this.$set(this, 'cart', res.data.data);
                    if(callback){
                        callback();
                    }
                })
        },
        // 选择商品
        selectGoods(val) {
            if(val.length == 0) {
                this.selectCount = val.length;
                this.selectTotalPrice = 0;
                this.submitGoodsArr = [];
            }
            else {
                this.selectCount = val.length;
                val.forEach(item => {
                    this.selectTotalPrice += parseFloat(item.last_price);
                });
                this.submitGoodsArr = val;
            }

        }
    }
}
</script>

<style scoped>
@import url(../../assets/css/base.css);

.mypurchase-order-main {
    position: relative;
    top: -63px;
    background-color: transparent;
}

.action-select-first,
.action-select-inventory {
    margin-left: 24px;
    width: 133px;
}

.action-select-first {
    margin-left: 0px;
}

.bg-head-nav {
    background-color: #d2f5e8;
    height: 64px;
}

.bg-head-h187 {
    height: 187px;
}

.table-container {
    position: relative;
}

.table-select-all {

    position: absolute;
    left: 55px;
    top: 13px;
    color: #888;
    z-index: 100;
}

.submitorder {
    position: fixed;
    left: 50%;
    bottom: 55px;
    transform: translate(-50%);
    width: 600px;
    height: 50px;
    background-color: #d2f5e8;
    border-radius: 7px;
    box-shadow: 2px 2px 3px #ccc;
}

.submitorder>.submit-order-text {
    display: inline-block;
    padding-left: 48px;
}

.submitorder>.submit-order-text>p {
    display: inline-block;
    line-height: 50px;
    margin: 0;
}

.submitorder>.submit-order-text>p>span {
    display: inline-block;
    line-height: 50px;
    font-size: 16px;
    color: #090909;
}

.submitorder>.submit-order-text>p:nth-of-type(2) {
    margin-left: 32px;
}

.btn-submitorder,
.return-prevpage {
    float: right;
    width: 125px;
    height: 40px;
    border-radius: 15px;
    margin-top: 5px;
}

.btn-submitorder {
    margin-left: 20px;
}

.goods-list-edit {
    float: right;
    font-size: 14px;
    padding: 16px 10px;
    cursor: pointer;
}
</style>
<style>
.mypurchase-order .dialog-group .el-radio__label {
    position: relative;
    left: -80px;
}
.mypurchase-order .dialog-group .add-address .el-dialog {
    width: 500px;
}
</style>




// WEBPACK FOOTER //
// src/pages/orderManage/MyPurchaseOrder.vue